import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "side-legend-container" }
const _hoisted_2 = { class: "side-legend-wr" }
const _hoisted_3 = {
  key: 0,
  class: "legend column"
}
const _hoisted_4 = {
  key: 1,
  class: "legend column"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($setup.props.isEstateMap)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "status side-panel",
              style: _normalizeStyle({ '--status-dot-color': $setup.C['gray'].bg })
            }, "Not Released", 4),
            _createElementVNode("div", {
              class: "status side-panel",
              style: _normalizeStyle({ '--status-dot-color': $setup.C['success'].bg })
            }, "Now Selling", 4),
            _createElementVNode("div", {
              class: "status side-panel",
              style: _normalizeStyle({ '--status-dot-color': $setup.C['warning'].bg })
            }, "Sold Out", 4)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "status side-panel",
              style: _normalizeStyle({ '--status-dot-color': $setup.C['gray'].bg })
            }, "Not Released", 4),
            _createElementVNode("div", {
              class: "status side-panel",
              style: _normalizeStyle({ '--status-dot-color': $setup.C['success'].bg })
            }, "Available", 4),
            _createElementVNode("div", {
              class: "status side-panel",
              style: _normalizeStyle({ '--status-dot-color': $setup.props.role === $setup.UserRoles.CUSTOMER ? $setup.C['light-blue'].bg : $setup.C['blue'].bg })
            }, _toDisplayString($setup.props.role === $setup.UserRoles.CUSTOMER ? "Hold" : "Pre-Contract"), 5),
            _createElementVNode("div", {
              class: "status side-panel",
              style: _normalizeStyle({ '--status-dot-color': $setup.C['yellow'].bg })
            }, _toDisplayString($setup.props.role === $setup.UserRoles.CUSTOMER ? "Under Contract" : "Reserved"), 5),
            _createElementVNode("div", {
              class: "status side-panel",
              style: _normalizeStyle({ '--status-dot-color': $setup.C['warning'].bg })
            }, _toDisplayString($setup.props.role === $setup.UserRoles.CUSTOMER ? "Sold" : "Settled"), 5),
            ($setup.props.role !== $setup.UserRoles.CUSTOMER)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", {
                    class: "status side-panel",
                    style: _normalizeStyle({ '--status-dot-color': $setup.C['primary'].bg })
                  }, "Unconditional", 4),
                  _createElementVNode("div", {
                    class: "status side-panel",
                    style: _normalizeStyle({ '--status-dot-color': $setup.C['orange'].bg })
                  }, "Option", 4),
                  _createElementVNode("div", {
                    class: "status side-panel",
                    style: _normalizeStyle({ '--status-dot-color': $setup.C['gray-middle'].bg })
                  }, "Offline", 4)
                ], 64))
              : _createCommentVNode("", true)
          ])),
      _createVNode($setup["LottrackrPoweredIcon"], { class: "side-legend-link" })
    ])
  ]))
}